export * from './src/ecom-recommendations-v1-recommendation-recommendations.universal.js';
